export enum NavRightSideSkeletonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
